<template>
      <span>
        <v-tooltip top class="tooltip-botao-visualizar-propostas">
            <a slot="activator" role="button"
               class="botao-enviar-reajuste secondary-color"
               @click.stop="$emit('eventoAbrirModalReadequacao')">
                  <i class="fas fa-upload ma-0" aria-hidden="true"/>
                  <span class="ml-1">Enviar Readequação | Doc. Complementar</span>
            </a>
            Clique para ver a mensagem do comprador.
            Em seguida, anexe o arquivo de Readequação/Doc. Complementar e preencha ou não uma observação.
        </v-tooltip>
      </span>
</template>

<script>
export default {
    name: 'BotaoEnviarReadequacao',
}
</script>

<style scoped lang="stylus">
    a.botao-enviar-reajuste *
        background-color transparent

    a.botao-enviar-reajuste
        min-width 50px
        font-size 14px
        display block

    a.deshabilidato
        pointer-events none


    .primary-color
        color var(--v-primary-lighten1) !important

    .secondary-color
        color var(--v-primary-lighten1) !important

    i
        font-size 13px
        top 0
</style>